












import { defineComponent } from '@vue/composition-api';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';

export default defineComponent({
    components: {
        SubTitle
    },
   
    setup() {
    },
});
